import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SIZES = {
    sm: { box: 22, font: 10, radius: 6 },
    md: { box: 26, font: 11.5, radius: 7 },
};
export function BrandMark({ size = 'md', withWordmark = false, className = '', label = 'Pipebase', logoUrl, }) {
    const s = SIZES[size];
    // Custom logo supplied → render that instead of the gradient tile.
    if (logoUrl) {
        return (_jsxs("span", { className: className, style: { display: 'inline-flex', alignItems: 'center', gap: 8, flexShrink: 0 }, children: [_jsx("img", { src: logoUrl, alt: label, style: {
                        height: s.box,
                        width: 'auto',
                        maxWidth: s.box * 4,
                        objectFit: 'contain',
                        display: 'block',
                    } }), withWordmark && label && (_jsx("span", { style: {
                        fontSize: 13.5,
                        fontWeight: 600,
                        letterSpacing: '-0.02em',
                        color: 'var(--text-1)',
                    }, children: label }))] }));
    }
    // Platform default — gradient tile + optional wordmark.
    return (_jsxs("span", { className: className, style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0,
        }, children: [_jsx("span", { "aria-label": label, style: {
                    width: s.box,
                    height: s.box,
                    borderRadius: s.radius,
                    background: 'radial-gradient(circle at 30% 28%, rgba(255,255,255,0.18), transparent 60%), linear-gradient(135deg, var(--brand-primary, var(--brand-400)), var(--brand-secondary, var(--brand-600)))',
                    display: 'grid',
                    placeItems: 'center',
                    color: 'white',
                    fontWeight: 700,
                    fontSize: s.font,
                    letterSpacing: '-0.04em',
                    boxShadow: '0 0 0 1px rgba(255,255,255,0.05) inset, 0 1px 0 rgba(255,255,255,0.18) inset',
                }, children: "42" }), withWordmark && (_jsx("span", { style: {
                    fontSize: 13.5,
                    fontWeight: 600,
                    letterSpacing: '-0.02em',
                    color: 'var(--text-1)',
                }, children: label }))] }));
}
//# sourceMappingURL=BrandMark.js.map